import { ENVIRONMENT_STATE_KEY } from './keys';

const getDefaultState = () => ({
  [ENVIRONMENT_STATE_KEY.MODULES]: [],
  [ENVIRONMENT_STATE_KEY.VALID_APPS]: [],
  [ENVIRONMENT_STATE_KEY.REGIONS]: {},
  [ENVIRONMENT_STATE_KEY.OUTER_ROUTE]: undefined,
  [ENVIRONMENT_STATE_KEY.ROUTES]: [],
  [ENVIRONMENT_STATE_KEY.CURRENT_PERSONA]: undefined,
  [ENVIRONMENT_STATE_KEY.BRAND_PROFILE]: {},
  [ENVIRONMENT_STATE_KEY.CURRENT_AGENT_STATUS]: {
    value: 'Online',
  },
  [ENVIRONMENT_STATE_KEY.CUSTOM_AWAY_REASONS]: [],
  [ENVIRONMENT_STATE_KEY.TOP_BAR_NOTIFICATION]: undefined,
  [ENVIRONMENT_STATE_KEY.LE_SOUND_ENABLE]: true,
  [ENVIRONMENT_STATE_KEY.LE_TRAIL_INFORMATION]: {},
  [ENVIRONMENT_STATE_KEY.PERSONALIZATION]: {
    [ENVIRONMENT_STATE_KEY.FEATURE_BY_ROUT_COUNT]: 0,
    [ENVIRONMENT_STATE_KEY.IS_OPEN]: false,
    [ENVIRONMENT_STATE_KEY.PAGE]: null,
    [ENVIRONMENT_STATE_KEY.IS_REPORTING_OPEN]: null,
  },
  [ENVIRONMENT_STATE_KEY.PERSONA_NOTIFICATION]: {
    agent: {
      count: 0,
      tooltip: '',
    },
    marketer: {
      count: 0,
      tooltip: '',
    },
    'agent-mngt': {
      count: 0,
      tooltip: '',
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/environment/defaults.js